import React, { useState} from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';
import { useTheme } from '@mui/material';
import SvgIcon from '../../../Helpers/Svg/SvgIcon';
import "./PurchasingProcess.scss";

export default function PurchasingProcess({ data, customData }) {
  const { title, description, processes } = !customData ? data : customData;
  const [processSelection, setProcessSelection] = useState(null);
  const theme = useTheme();

  const handleProcessSelection = (process) => {
    if (processSelection === process) {
      setProcessSelection(null);
    } else {
      setProcessSelection(process);
    }
  };

  return (
    <div id="service-value" className="purchasing-process-wrapper">
      <Container>
        <div className="purchasing-process-container">
          <div className="purchasing-process-header">
            <h2>{title}</h2>
            <p>{description}</p>
          </div>
          <div className={`purchasing-process-body backgroundBeforeStyles`}>
            <ul className="processList">
              {processes.map((process, i) => {
                return (
                  <li key={(`processTitle${i}`)} className={(processSelection === i ? " selected" : "")} onClick={() => handleProcessSelection(i)}>
                    <span className={`process-badge backgroundStyles backgroundBeforeStyles`}>{(i+1)}</span><span className="process-title">{process.title}</span>
                    <SvgIcon viewBox={"0 0 12 65"} iconName={"title_guide"} color={theme.palette.primary.main} />
                  </li>)
              })}
            </ul>
          </div>
          <div className="process-information-container">
              {processes.map((process, i) => {
                return (
                  (processSelection === i) && 
                  <div key={(`processDescription${i}`)} className={`process-content borderStyles`}>
                    <h3>{process.title}</h3>
                    <p dangerouslySetInnerHTML={{__html: process.description}}></p>
                  </div>)
              })}
            </div>
        </div>
      </Container>
    </div>
  );
}

PurchasingProcess.propTypes = {
  data: PropTypes.object.isRequired,
  customData: PropTypes.object,
};
